import React from 'react';
import { Thumbnail } from '@icecreamsocial/components';
import nmiLogo from '../../../assets/logo_nmi.jpg';

const NmiLogo = ({ ...props }) => <Thumbnail src={nmiLogo} {...props} />;

NmiLogo.displayName = 'NmiLogo';

export default NmiLogo;
